const canEditAssignment = (assignment, userCourses) =>
  assignment.type === "personal" ||
  userCourses?.some((course) => course.id === assignment.course_id);

export default canEditAssignment;
